import React, { useContext } from 'react'
import OptionStep4 from 'app/React/Components/Form/Step4/OptionStep4'
import Tip from 'app/React/Components/misc/Tip'
import clx from 'classnames'
import { FeatureFlag } from 'utils/feature-flag'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SettingStep4(props) {
  const {
    order,
  } = useContext(ConfiguratorContext)

  const setting = props.setting
  const options = Array.isArray(setting.options) ? { ...setting.options } : setting.options

  const optionValues = Object.values(options).filter(option => {
    if (!FeatureFlag.accessoryShop()) {
      return false
    }

    return option.hide_on !== order.paymentType && option.hide_on !== 'all'
  })

  const option_elements = Object.keys(options).map((key) => (
    <OptionStep4
      key={key}
      option={options[key]}
      layout={setting.layout}
      settingid={setting.id}
      onChange={props.onChange}
      required={setting.required && setting.required !== '0'}
    />))

  if (
    optionValues.filter(
      (o) =>
        !(
          o.hide_on === order.paymentType ||
          o.hide_on === 'all' ||
          (!FeatureFlag.accessoryShop() && o.type === 'accessory-product')
        )
    ).length <= 0
  ) {
    return null
  }

  return (
    <>
      <div className={clx('setting', props.className)} data-setting-id={setting.id}>
        <h3 className='config-subtitle'>
          {setting.label}
          {typeof setting.description === 'string' && setting.description.length > 0 ? (
            <Tip button='Ok' content={setting.description}/>
          ) : null}
        </h3>
        <div className='config-radio' data-option-count={0}>
          {option_elements}
        </div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}

SettingStep4.defaultProps = {
  onChange: null,
  className: ''
}
